<template>
  <header class="info__head">
    <div class="info__head-inner">
      <div class="info__head-item">
        <p class="info__title"> {{this.heading}} </p>
      </div>

      <div class="info__head-item">
        <slot></slot>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "FormInfoHeader",
  props: {
    heading: {
      type: String,
      required: false,
    }
  },
}
</script>